import Icon, { IconNames } from "../../../../Foundation/Icons";
import { IconColours } from "../../../../Foundation/Icons/interface";
import styles from "./mediaCardPlaceholder.module.scss";
import classNames from "classnames";

export interface MediaCardPlaceholderProps {
    aspectRatio?: number;
}

const MediaCardPlaceholder = ({ aspectRatio }: MediaCardPlaceholderProps) => {
    const cardClasses = classNames(styles.mediaCardPlaceholder, {
        [styles.horizontalVideo]: aspectRatio === 1.7778,
    });
    return (
        <div className={cardClasses} data-testid="mediaCardPlaceholder">
            <div className={styles.mediaCardPlaceholderImage}>
                <Icon
                    type="filled"
                    name={IconNames.Play}
                    colour={IconColours.white}
                    title=""
                    ariaHidden={true}
                    className={styles.playButton}
                />
            </div>
            <div className={styles.mediaCardPlaceholderHeadline} />
            <div className={styles.mediaCardPlaceholderDescription} />
        </div>
    );
};

export default MediaCardPlaceholder;
